/**
 * TEMPL — keeps the displayed price in sync with Loop's purchase-option toggle.
 *
 * WHAT IT DOES
 * ------------
 * snippets/price.liquid renders the product page price and the sticky add-to-cart
 * price as:
 *
 *   <span data-templ-price data-state="subscription"
 *         data-sub="$33.99" data-onetime="$39.99">
 *     <span class="templ-price__compare">$39.99</span>   <- struck through
 *     <span class="templ-price__current">$33.99</span>
 *   </span>
 *
 * This script flips that between the two prices as the shopper switches between
 * "Subscribe & Save" and "One-time".
 *
 * HOW SELECTION IS DETECTED
 * -------------------------
 * Loop keeps a hidden <input name="selling_plan"> inside the product form and
 * writes to it from its own listener. Verified Aug 28 2026 on GENESIS: the input
 * is present on load with the selling plan id, becomes "" on One-time, and is
 * restored on Subscribe & Save. Reading that input is the single source of truth —
 * it is the field that actually decides what gets bought, so the price can never
 * disagree with the cart.
 *
 * WHY SO MANY TRIGGERS
 * --------------------
 * Loop does not emit an event we can rely on, and it rebuilds its widget
 * asynchronously (and again on every variant change). The theme also replaces the
 * price container and morphs the sticky bar on variant change, which resets the
 * markup to its server-rendered "subscription" default. So: run on click/change,
 * on a short trailing schedule, on DOM insertions, and on a slow safety interval.
 * Every pass is idempotent and returns immediately when nothing has changed.
 *
 * The MutationObserver watches childList only, never attributes — this script
 * writes data-state, and an attribute observer would re-trigger itself into a loop
 * (the mistake the old theme.liquid observer made).
 */
(function () {
  if (window.__templSubscriptionPrice) return;
  window.__templSubscriptionPrice = true;

  var TRAILING_PASSES = [0, 150, 400, 900, 1800];

  function isSubscriptionSelected() {
    var input = document.querySelector('input[name="selling_plan"]');
    if (!input) return true; // no Loop input yet: keep the server-rendered default
    return String(input.value || '').trim() !== '';
  }

  function apply() {
    var state = isSubscriptionSelected() ? 'subscription' : 'onetime';
    var nodes = document.querySelectorAll('[data-templ-price]');

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.state === state) continue;

      var current = el.querySelector('.templ-price__current');
      var subscribed = state === 'subscription';

      if (current) {
        current.textContent = subscribed ? el.dataset.sub : el.dataset.onetime;
      }

      // The struck-through one-time price and the "Sale price" screen-reader label
      // both belong to the subscription state only. Inline style rather than
      // [hidden] so theme rules on .compare-at-price can't win the cascade and
      // leave a stale struck-through price on screen.
      var hideable = el.querySelectorAll('.templ-price__compare, .templ-price__label');
      for (var j = 0; j < hideable.length; j++) {
        hideable[j].style.display = subscribed ? '' : 'none';
      }

      el.dataset.state = state;
    }
  }

  function schedule() {
    if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
    for (var i = 0; i < TRAILING_PASSES.length; i++) {
      window.setTimeout(apply, TRAILING_PASSES[i]);
    }
  }

  function start() {
    apply();

    // Loop's options are plain divs, and its frequency dropdown fires change.
    document.addEventListener('click', schedule, true);
    document.addEventListener('change', schedule, true);

    // Variant changes re-render the price block and morph the sticky bar back to
    // the server-rendered default; catch the re-insert.
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = window.setTimeout(function () {
          pending = null;
          apply();
        }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Safety net for anything the triggers above miss. Cheap: one input read.
    window.setInterval(apply, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
